import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "transfer-options__info" };
const _hoisted_2 = { class: "transfer-options__param" };
const _hoisted_3 = { class: "transfer-options__label" };
const _hoisted_4 = { class: "transfer-options__value" };
const _hoisted_5 = { class: "transfer-options__param" };
const _hoisted_6 = { class: "transfer-options__label" };
const _hoisted_7 = { class: "transfer-options__value" };
const _hoisted_8 = { class: "transfer-options__param" };
const _hoisted_9 = { class: "transfer-options__label" };
const _hoisted_10 = {
    key: 0,
    class: "transfer-options__value"
};
import ImportProfileInputPassword from "../components/ImportProfileInputPassword.vue";
import CopyToClipboard from "@astina/paloma-common-ui/src/components/CopyToClipboard.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfileTransferSftp',
    props: {
        profile: {},
        transferInformation: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('import_profile.transfer.host')), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(__props.transferInformation.sftp.host) + " ", 1),
                        _createVNode(CopyToClipboard, {
                            value: __props.transferInformation.sftp.host
                        }, null, 8, ["value"])
                    ])
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('import_profile.transfer.port')), 1),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, [
                        _createTextVNode(_toDisplayString(__props.transferInformation.sftp.port) + " ", 1),
                        _createVNode(CopyToClipboard, {
                            value: __props.transferInformation.sftp.port.toString()
                        }, null, 8, ["value"])
                    ])
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('import_profile.transfer.username')), 1),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (__props.profile.inputUsername)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(__props.profile.inputUsername) + " ", 1),
                            _createVNode(CopyToClipboard, {
                                value: __props.profile.inputUsername
                            }, null, 8, ["value"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(ImportProfileInputPassword, { profile: __props.profile }, null, 8, ["profile"])
            ]));
        };
    }
});
